export function season() {
    let seasonBtn = document.querySelector('[data-season]');

    function toggle() {
        let currentValue = seasonBtn.getAttribute('data-season');
        seasonBtn.setAttribute('data-season', currentValue == 'winter' ? 'summer' : 'winter');
    }

    seasonBtn.addEventListener('click', toggle);
}
